var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlayAudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9405 6.33706C15.5735 7.26475 16.8567 7.99375 17.7709 8.66154C18.6913 9.33392 19.3721 10.0367 19.6159 10.9632C19.7947 11.6427 19.7947 12.3574 19.6159 13.0369C19.3721 13.9634 18.6913 14.6662 17.7709 15.3386C16.8567 16.0064 15.5735 16.7354 13.9406 17.663L13.9406 17.663C12.3632 18.5592 11.033 19.3149 10.0232 19.7444C9.0053 20.1774 8.07729 20.3968 7.17536 20.1412C6.51252 19.9534 5.90941 19.5969 5.42356 19.1067C4.76419 18.4414 4.49951 17.522 4.37429 16.4154C4.24998 15.317 4.24999 13.879 4.25 12.0502V12.0502V11.95V11.95C4.24999 10.1211 4.24998 8.68315 4.37429 7.5847C4.49951 6.47816 4.76419 5.55867 5.42356 4.89341C5.90941 4.40323 6.51252 4.04672 7.17536 3.8589C8.07729 3.60331 9.0053 3.82275 10.0232 4.25571C11.033 4.68522 12.3632 5.4409 13.9405 6.33706Z",
    fill: "#242428"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayAudio);
export default __webpack_public_path__ + "static/media/icon-play-audio.4659105cbe9f80477868246202361a95.svg";
export { ForwardRef as ReactComponent };